/**
 * Badge state
 * @enum {string}
 * @property {string} OPEN - Badge state open.
 * @property {string} CLOSE - Badge state close.
 */
export var BadgeState;
(function (BadgeState) {
    BadgeState["ACTIVE"] = "ACTIVE";
    BadgeState["DEFAULT"] = "DEFAULT";
    BadgeState["DISABLED"] = "DISABLED";
})(BadgeState || (BadgeState = {}));
//# sourceMappingURL=state.js.map